export const Permissions = {

    ALL: -1
}
